import {
  FinanceFormValues,
  ValidationFormErrors,
  ValidationFormsModeEnum,
} from "./types";

export function validateFinance(
  values: FinanceFormValues,
  mode: ValidationFormsModeEnum,
  original?: FinanceFormValues
): ValidationFormErrors {
  const errors: ValidationFormErrors = {};

  if (!values.name || values.name.trim() === "") {
    errors.name = "Введіть назву.";
  }

  if (!values.type || values.type.trim() === "") {
    errors.type = "Оберіть тип.";
  }

  // if (!values.project || values.project.name.trim() === "") {
  //   errors.project = "Проєкт має бути введеним.";
  // }

  if (!values.selling?.name && !values.project?.name) {
    errors.selling = "У об'єкта має бути або проєкт або продаж."
  }


  if (!values.budget || isNaN(Number(values.budget))) {
    errors.budget = "Введіть коректне число.";
  }

  if (mode === "edit" && original) {

  }

  return errors;
}
